module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-groups"
  }, [_c('div', {
    staticClass: "order-header"
  }, [(_vm.editabled) ? _c('span', [_c('Checkbox', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "on-change": _vm.selectAll
    }
  }, [_vm._v("Selected All")])], 1) : _vm._e(), _vm._v(" "), (_vm.editabled === false) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Category")]), _vm._v(" "), _c('span', [_vm._v("Unit Price")]), _vm._v(" "), _c('span', [_vm._v("Quantity")]), _vm._v(" "), _c('span', [_vm._v("Selected all")]), _vm._v(" "), _c('span', [_vm._v("Operation")])]), _vm._v(" "), _vm._t("default", [_c('order-list')])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-134b7cfa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Common/OrderGroup.vue
// module id = 784
// module chunks = 0